import { inject, Component } from '@angular/core';
import { AuthenticationService } from '../service/auth/authentication.service';
import { TeilgebietSelectionService } from '../service/common/teilgebiet/teilgebiet-selection.service';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';

@Component({
    selector: 'redispatch-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: [
        './welcome.component.scss',
    ],
    standalone: false,
})
export class WelcomeComponent {

    public authenticationService = inject(AuthenticationService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private route = inject(ActivatedRoute);

    displayLoginError$ = this.route.queryParams.pipe(
        map(params => params['error'] === 'true'),
    );

    public login(): void {
        this.authenticationService.login();
    }

    public async logout() : Promise<void> {
        this.teilgebietSelectionService.resetSelection();
        try {
            await this.authenticationService.logout();
        } catch (error) {
            console.error('Logout fehlgeschlagen', error);
        }
    }

}
